module.exports = __webpack_public_path__ + "media/images/banner-assets/zh-cn/banner3-6d7be3f7efbd3495f0d9847be7d0185b.jpg";